import TypedNativeModules from "../internal/TypedNativeModules";

export async function logNonFatal(
  message: string,
  errCode: number,
  errDomain: string,
  otherUserInfo: Record<string, string>,
): Promise<void> {
  await TypedNativeModules.RNTareBridge.logNonFatal(message, errCode, errDomain, otherUserInfo);
}
